import { View, ViewModel } from "binder"
import { ExpanderViewModel } from "./expander-viewModel"

export class ExpanderView extends View<ExpanderViewModel>{
    GetViewUniqueId(): string {
        return "V-BEF1FECA-5075-417C-AB3C-D3B3B0FFCEA8"
    }
    loadHtml(): string {
        let element = require('./expander.html').default;
        let style = require('./expander.less');
        return element;
    }
    constructor() {
       super();
    }
    public set header(v: ViewModel) { this._header = v; } public get header(): ViewModel { return this._header;} private _header: ViewModel;
    public set body(v: ViewModel) { this._body = v; } public get body(): ViewModel { return this._body;} private _body: ViewModel;

}
